import React from "react"
import styled from "styled-components"

import { MailSVG, FaxSVG, LinkSVG, PhoneSVG } from "../general/svgs/SVGs"

const StyledLocation = styled.div`
  border: 1px solid #cbc8b9;
  background-color: #ffffff;
  box-shadow: 0 10px 19px 0 rgba(124, 125, 83, 0.34);
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  svg {
    margin-right: 3px;
  }
`

const PreTitle = styled.h6`
  color: #cbc8b9;
  font-family: Lato;
  font-size: 13px;
  font-weight: 900;
  line-height: 16px;
  margin: 0;
`

const Title = styled.h5`
  color: #3b3b3b;
  font-family: Lato;
  font-size: 16px;
  font-weight: 900;
  line-height: 16px;
  margin: 0;
  margin-bottom: 8px;
`

const Address = styled.p`
  color: #3b3b3b;
  font-family: Lato;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
`

const ContactInfoContainer = styled.div`
  margin-top: 16px;
`

const ContactLine = styled.span`
  color: #3b3b3b;
  font-family: Lato;
  font-size: 13px;
  line-height: 24px;
  display: block;
`

const Location = props => {
  return (
    <StyledLocation onClick={props.onClick}>
      <PreTitle>{props.location.pretitle}</PreTitle>
      <Title>{props.location.title}</Title>
      <Address dangerouslySetInnerHTML={{ __html: props.location.address }} />
      <ContactInfoContainer>
        {props.location.phone ? (
          <ContactLine>
            {" "}
            <PhoneSVG /> {props.location.phone}
          </ContactLine>
        ) : null}
        {props.location.fax ? (
          <ContactLine>
            {" "}
            <FaxSVG /> {props.location.fax}
          </ContactLine>
        ) : null}
        {props.location.email ? (
          <ContactLine>
            {" "}
            <MailSVG /> {props.location.email}
          </ContactLine>
        ) : null}
        {props.location.link ? (
          <ContactLine>
            {" "}
            <LinkSVG /> {props.location.link}
          </ContactLine>
        ) : null}
      </ContactInfoContainer>
    </StyledLocation>
  )
}

export default Location
